import { TRACKING_TYPE } from '@/lib/constants';
import { ShipmentModel } from '@/lib/models/shipment/types';

export const getShipmentIdTypeLabel = ({
  containerNumber,
  mblNumber,
  awbNumber,
  bookingNumber,
  parcelNumber,
  associatedContainers,
}: {
  containerNumber?: string;
  mblNumber?: string;
  awbNumber?: string;
  bookingNumber?: string;
  parcelNumber?: string;
  associatedContainers?: ShipmentModel['associatedContainers'];
}): { type: string; label: string } => {
  if (associatedContainers?.length) {
    if (bookingNumber) {
      return { type: TRACKING_TYPE.BOOKING, label: bookingNumber || 'Unknown' };
    }
    return { type: TRACKING_TYPE.MBOL, label: mblNumber || 'Unknown' };
  }
  if (containerNumber) {
    return { type: TRACKING_TYPE.CONTAINER, label: containerNumber };
  }
  if (awbNumber) {
    return { type: TRACKING_TYPE.AWB, label: awbNumber };
  }
  if (parcelNumber) {
    return { type: TRACKING_TYPE.PARCEL, label: parcelNumber };
  }
  if (mblNumber) {
    return { type: TRACKING_TYPE.MBOL, label: mblNumber };
  }
  if (bookingNumber) {
    return { type: TRACKING_TYPE.BOOKING, label: bookingNumber };
  }
  return { type: '', label: '' };
};
